import styled from "@emotion/styled";
import { AdminImg } from "./assets";
import { ProfileDropdown } from "./prtnr";

function Navbar(props) {
  return (
    <Header>
      <HeaderWrapper>
        <Left>
          <Logo>
            <Logo1>
              <Vector xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="rgb(26, 32, 66)"
                  d="M8.30052 0C9.53868 0 10.6512 0.169308 11.6378 0.507912C12.6246 0.846504 13.4663 1.32532 14.1631 1.94434C14.8592 2.56392 15.391 3.31847 15.7585 4.20798C16.1261 5.09748 16.31 6.08434 16.3105 7.16854C16.3105 8.2519 16.1266 9.22882 15.7585 10.0993C15.3906 10.9698 14.8588 11.7099 14.1631 12.3197C13.4662 12.9288 12.6245 13.3979 11.6378 13.7268C10.6513 14.0557 9.5388 14.2202 8.30052 14.2205L4.58556 14.2205L4.58556 19.4442L0 19.4442L0 0L8.30052 0ZM8.01012 10.1865C9.15168 10.1865 10.0368 9.92087 10.6655 9.38938C11.2942 8.85791 11.6088 8.12755 11.6095 7.19832C11.6095 6.25078 11.2949 5.51077 10.6655 4.97832C10.0361 4.44588 9.15096 4.18014 8.01012 4.18112L4.58556 4.18112L4.58556 10.1865L8.01012 10.1865Z"
                />
              </Vector>
              <Vector_0001 xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="rgb(26, 32, 66)"
                  d="M7.19784 0C8.2032 0 9.11736 0.202801 9.94044 0.608401C10.7635 1.01399 11.4552 1.5944 12.0155 2.34965L12.0155 0.260148L16.3685 0.260148L16.3685 15.5834L12.0155 15.5834L12.0155 13.5241C11.5702 14.2399 10.9171 14.8058 10.0565 15.2217C9.19572 15.6377 8.24292 15.8456 7.19784 15.8455C6.153 15.8455 5.19036 15.6471 4.30992 15.2505C3.44604 14.8661 2.67048 14.3078 2.0316 13.6107C1.39296 12.9144 0.894841 12.0823 0.537241 11.1143C0.179641 10.1463 0.00048 9.08242 0 7.9225C0 6.74278 0.174121 5.66421 0.522601 4.68672C0.870961 3.70924 1.35936 2.8726 1.98792 2.17679C2.61732 1.47986 3.3768 0.942877 4.26624 0.565813C5.1558 0.188748 6.13296 0.000564 7.19784 0ZM8.2422 11.7818C8.80356 11.7818 9.31152 11.6852 9.76596 11.4921C10.2104 11.3059 10.6145 11.0352 10.9559 10.6949C11.2973 10.3515 11.5642 9.9415 11.7398 9.4903C11.923 9.02554 12.0148 8.51278 12.0155 7.9519C12.0155 6.81106 11.6671 5.8825 10.9705 5.16608C10.2739 4.44972 9.36444 4.09182 8.2422 4.09238C7.7004 4.09238 7.19736 4.18916 6.7332 4.38272C6.2832 4.56671 5.87376 4.83761 5.52852 5.17993C5.19 5.51867 4.92888 5.92486 4.74516 6.39862C4.56156 6.87226 4.46964 7.38982 4.46952 7.95106C4.46952 8.49286 4.56636 9.00082 4.75992 9.47482C4.95348 9.9487 5.2146 10.3551 5.54328 10.694C5.87208 11.0329 6.26868 11.2987 6.7332 11.4913C7.19772 11.6839 7.70064 11.7812 8.2422 11.7818Z"
                />
              </Vector_0001>
              <Vector_0002 xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="rgb(26, 32, 66)"
                  d="M7.1976 0.00125999C8.20368 0.00125999 9.11784 0.204049 9.94008 0.609649C10.7623 1.01524 11.454 1.59566 12.0151 2.35091L12.0151 0.261396L16.3687 0.261396L16.3687 15.5847L12.0151 15.5847L12.0151 13.5253C11.5698 14.2411 10.9169 14.8071 10.0561 15.223C9.19548 15.6389 8.24256 15.8469 7.1976 15.8467C6.15252 15.8467 5.19 15.6484 4.31016 15.2518C3.44628 14.8673 2.67084 14.3091 2.03184 13.612C1.39356 12.9156 0.8952 12.0835 0.53688 11.1155C0.17856 10.1476 -0.000359458 9.08366 5.42172e-07 7.92374C5.42172e-07 6.74402 0.174237 5.66545 0.522597 4.68797C0.871077 3.71048 1.35948 2.87384 1.98804 2.17804C2.61672 1.48126 3.37632 0.944052 4.26672 0.566424C5.15724 0.188808 6.13416 0 7.1976 0M8.24256 11.7825C8.8032 11.7825 9.31116 11.6859 9.76644 11.4927C10.2108 11.3063 10.6148 11.0356 10.9561 10.6955C11.2972 10.3521 11.5638 9.9419 11.7395 9.49094C11.9233 9.02618 12.0151 8.5133 12.0151 7.95254C12.0151 6.81171 11.6669 5.88302 10.9702 5.16671C10.2736 4.45034 9.36444 4.09244 8.24292 4.09301C7.70112 4.09301 7.19808 4.18979 6.73392 4.38335C6.28368 4.56697 5.87424 4.83792 5.52924 5.18056C5.18544 5.52718 4.91844 5.94242 4.74588 6.39926C4.56156 6.87374 4.46976 7.3913 4.47024 7.9517C4.47024 8.4935 4.56684 9.00134 4.76004 9.47534C4.95312 9.94934 5.21448 10.3558 5.54424 10.6947C5.87268 11.0335 6.26928 11.2993 6.73392 11.4918C7.19856 11.6844 7.70112 11.7819 8.24256 11.7825Z"
                />
              </Vector_0002>
              <Vector_0003 xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="rgb(26, 32, 66)"
                  d="M0 0.291192L4.3536 0.291192L4.3536 3.04804C4.99188 2.02301 5.7996 1.25874 6.77664 0.755244C7.75368 0.251748 8.80332 0 9.92556 0L9.92556 4.29629C9.11268 4.27714 8.36784 4.35448 7.69092 4.52832C7.014 4.70216 6.42864 4.9679 5.93496 5.32553C5.44692 5.67727 5.049 6.13964 4.77396 6.67472C4.49424 7.21652 4.35444 7.85504 4.35444 8.59028L4.35444 15.6136L0 15.6136L0 0.291192Z"
                />
              </Vector_0003>
              <Vector_0004 xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="rgb(26, 32, 66)"
                  d="M6.96516 0L6.96516 4.35335L10.6218 4.35335L10.6218 7.83587L6.96516 7.83587L6.96516 14.1334C6.96516 14.9658 7.1586 15.5124 7.54524 15.7733C7.932 16.0342 8.66736 16.126 9.7512 16.0489C9.80892 16.0489 9.95448 16.0395 10.1866 16.02C10.4185 16.0005 10.5642 15.9906 10.6218 15.9906L10.6218 19.7056C10.3897 19.7437 10.061 19.7825 9.63588 19.8216C9.21072 19.8607 8.88204 19.8802 8.64984 19.8799C6.57876 20.0149 5.055 19.6617 4.07844 18.8203C3.102 17.9789 2.61348 16.6681 2.61288 14.8879L2.61288 7.83587L0 7.83587L0 4.35335L2.61168 4.35335L2.61168 0L6.96516 0Z"
                />
              </Vector_0004>
              <Vector_0005 xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="rgb(26, 32, 66)"
                  d="M0 0.290352L4.3536 0.290352L4.3536 2.32195C4.9728 1.58686 5.69821 1.01608 6.52981 0.609648C7.36141 0.20322 8.22301 0 9.11341 0C9.92581 0 10.6662 0.145104 11.3334 0.435312C11.985 0.714324 12.5694 1.12998 13.0458 1.65419C13.5198 2.17685 13.8918 2.79601 14.163 3.51168C14.4342 4.22734 14.5698 5.01097 14.5698 5.86259L14.5698 15.6137L10.2162 15.6137L10.2162 6.79066C10.2162 5.93998 9.9786 5.25329 9.5046 4.73076C9.0318 4.20824 8.397 3.94699 7.6038 3.94699C7.1718 3.94457 6.7458 4.03914 6.3558 4.2237C5.96856 4.40807 5.62273 4.66987 5.34001 4.99301C5.04157 5.33596 4.806 5.72881 4.64388 6.15358C4.46952 6.59842 4.3728 7.08214 4.3536 7.60474L4.3536 15.6147L0 15.6147L0 0.290352Z"
                />
              </Vector_0005>
              <Vector_0006 xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="rgb(26, 32, 66)"
                  d="M4.55641 9.11182C4.73041 10.0795 5.14201 10.839 5.79001 11.3901C6.43681 11.9413 7.2552 12.2169 8.2428 12.2172C8.9388 12.2172 9.54241 12.072 10.056 11.7818C10.5684 11.4917 10.9224 11.0853 11.1156 10.5631L15.4392 10.5631C14.994 12.2849 14.124 13.6003 12.828 14.5095C11.532 15.4188 9.94561 15.8733 8.06761 15.8731C6.88801 15.8731 5.79961 15.6798 4.80361 15.293C3.80641 14.9064 2.9556 14.3651 2.2488 13.6693C1.5432 12.9727 0.991202 12.1358 0.596402 11.1589C0.200402 10.182 0.0012 9.1129 0 7.95166C0 6.79078 0.193201 5.72202 0.580801 4.74524C0.967201 3.76846 1.50841 2.9316 2.20561 2.23469C2.90161 1.53818 3.73441 0.991608 4.70161 0.59496C5.67001 0.198324 6.7332 0 7.8948 0C8.958 0 9.94921 0.164544 10.8684 0.493632C11.7888 0.82272 12.5916 1.27727 13.2768 1.85728C13.9668 2.44151 14.5344 3.1567 14.946 3.96146C15.372 4.78412 15.6228 5.68853 15.7008 6.67474C15.7392 7.12006 15.7632 7.47322 15.7728 7.73434C15.7836 7.99546 15.7884 8.19382 15.7872 8.3293C15.7872 8.60038 15.7776 8.8615 15.7584 9.11266L4.55641 9.11182ZM11.376 6.52906C11.2788 5.65846 10.926 4.97644 10.3176 4.48301C9.70801 3.98958 8.9388 3.74286 8.01 3.74286C7.158 3.74286 6.432 3.98958 5.832 4.48301C5.2332 4.97644 4.8264 5.65846 4.614 6.52906L11.376 6.52906Z"
                />
              </Vector_0006>
              <Vector_0007 xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="rgb(26, 32, 66)"
                  d="M0 0.291192L4.3536 0.291192L4.3536 3.04804C4.992 2.02301 5.7996 1.25874 6.7764 0.755244C7.7532 0.251748 8.8032 0 9.9252 0L9.9252 4.29629C9.1128 4.27714 8.3676 4.35448 7.6908 4.52832C7.014 4.70216 6.4284 4.9679 5.9352 5.32553C5.4468 5.67727 5.0496 6.13964 4.7736 6.67472C4.494 7.21652 4.3536 7.85504 4.3536 8.59028L4.3536 15.6136L0 15.6136L0 0.291192Z"
                />
              </Vector_0007>
              <Vector_0008 xmlns="http://www.w3.org/2000/svg">
                <path
                  fill="rgb(26, 32, 66)"
                  d="M4.37161 2.12768C4.37161 3.33419 3.4248 4.28118 2.1924 4.28118C0.973195 4.28118 0 3.33419 0 2.12768C0 0.946992 0.973195 0 2.1924 0C3.4236 0 4.37161 0.946992 4.37161 2.12768ZM0.544794 2.12768C0.544794 3.07468 1.2444 3.82699 2.2056 3.82699C3.1392 3.82699 3.82679 3.07447 3.82679 2.14027C3.82679 1.19328 3.1392 0.427764 2.1924 0.427764C1.2456 0.427764 0.544794 1.1935 0.544794 2.12768ZM1.854 3.24251L1.3608 3.24251L1.3608 1.11566C1.5564 1.07664 1.82879 1.05084 2.17919 1.05084C2.58119 1.05084 2.76361 1.11566 2.91841 1.2065C3.03601 1.29734 3.12599 1.466 3.12599 1.6735C3.12599 1.90699 2.94481 2.08867 2.68561 2.1665L2.68561 2.19356C2.89321 2.2714 3.0096 2.42706 3.0744 2.71259C3.1404 3.03692 3.18 3.16657 3.2304 3.2444L2.69881 3.2444C2.63401 3.16657 2.59439 2.97168 2.53079 2.72538C2.49239 2.49188 2.36281 2.38804 2.09041 2.38804L1.854 2.38804L1.854 3.24251ZM1.8672 2.036L2.10121 2.036C2.37361 2.036 2.59319 1.94518 2.59319 1.72468C2.59319 1.53 2.45161 1.40034 2.13961 1.40034C2.04841 1.39834 1.9572 1.40699 1.8672 1.42615L1.8672 2.036Z"
                />
              </Vector_0008>
              <Group1>
                <Image19 />
              </Group1>
            </Logo1>
          </Logo>
        </Left>
        <ProfileDropdown name={"Admin"} imageUrl={AdminImg} />
      </HeaderWrapper>
    </Header>
  );
}

export default Navbar;

const Header = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const HeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  flex: 1;
  border-radius: 12px;
  width: 1200px;
  box-sizing: border-box;
  padding: 24px 16px;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  gap: 8px;
  box-sizing: border-box;
`;

const Logo = styled.div`
  width: 165px;
  height: 24px;
  position: relative;
`;

const Logo1 = styled.div`
  width: 166px;
  height: 24px;
  overflow: hidden;
  position: absolute;
  left: 0px;
  top: 0px;
`;

const Vector = styled.svg`
  width: 16px;
  height: 19px;
  position: absolute;
  left: 34px;
  top: 2px;
  right: 116px;
  bottom: 2px;
`;

const Vector_0001 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 52px;
  top: 6px;
  right: 98px;
  bottom: 2px;
`;

const Vector_0002 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 70px;
  top: 6px;
  right: 79px;
  bottom: 2px;
`;

const Vector_0003 = styled.svg`
  width: 10px;
  height: 16px;
  position: absolute;
  left: 90px;
  top: 6px;
  right: 66px;
  bottom: 2px;
`;

const Vector_0004 = styled.svg`
  width: 11px;
  height: 20px;
  position: absolute;
  left: 101px;
  top: 2px;
  right: 54px;
  bottom: 2px;
`;

const Vector_0005 = styled.svg`
  width: 15px;
  height: 16px;
  position: absolute;
  left: 114px;
  top: 6px;
  right: 37px;
  bottom: 2px;
`;

const Vector_0006 = styled.svg`
  width: 16px;
  height: 16px;
  position: absolute;
  left: 131px;
  top: 6px;
  right: 19px;
  bottom: 2px;
`;

const Vector_0007 = styled.svg`
  width: 10px;
  height: 16px;
  position: absolute;
  left: 149px;
  top: 6px;
  right: 7px;
  bottom: 2px;
`;

const Vector_0008 = styled.svg`
  width: 4px;
  height: 4px;
  position: absolute;
  left: 161px;
  top: 6px;
  right: 1px;
  bottom: 14px;
`;

const Group1 = styled.div`
  width: 25px;
  height: 24px;
  position: absolute;
  left: 0px;
  top: 0px;
`;

const Image19 = styled.div`
  width: 25px;
  height: 24px;
  background: url("https://d3nakrlcog1u3z.cloudfront.net/1750234477816-4b35a886422bef44a2225fae3321414ad27d07ab (1).png");
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  top: 0px;
  right: 0px;
`;
